import { h, Component } from 'preact'
import { GetServerSideProps } from '../../server-middleware/context'
import ShowMoreButton from './ShowMoreButton'
import QuickLinksList from './QuickLinksList'
import QuickLink from './QuickLink'
import { z } from 'zod'

interface State {
  showAll?: boolean
}

export const widgetName = 'quick_links' as const

export const config = z.object({
  title: z.string().optional(),
  quickLinks: z.array(z.object({
    title: z.string(),
    url: z.string(),
    description: z.string(),
    openNewTab: z.boolean(),
    iconSrc: z.string().or(z.null()),
    imageSrc: z.string().or(z.null())
  })).default([]),
  enableBorder: z.boolean(),
  borderRadius: z.number()
})

type Config = z.infer<typeof config>

interface QuickLinkItem {
  title: string
  url: string
  description: string
  openNewTab: boolean
  imageSrc: string|null
  iconSrc: string|null
}

interface Props {
  showAll?: boolean
  data: QuickLinkItem[]
  title?: string
  itemsPerContainer: number
  settings: {
    enableBorder: boolean
    borderRadius: number
  }
}

export const getServerSideProps: GetServerSideProps<Config, Props> = async (ctx, config) => {
  return {
    data: config.quickLinks,
    title: config.title,
    settings: {
      enableBorder: config.enableBorder,
      borderRadius: config.borderRadius
    },
    itemsPerContainer: 6
  }
}

export default class QuickLinksContainer extends Component<Props, State> {
  constructor (props: Props) {
    super()
    this.state = {
      showAll: props.showAll
    }
    this.showMoreHandler = this.showMoreHandler.bind(this)
  }

  showMoreHandler () {
    this.setState({
      showAll: !this.state.showAll
    })
  }

  render (props: Props, state: State) {
    const { data, settings, itemsPerContainer, title } = props
    const { showAll } = state

    if (!data.length) {
      return null
    }

    return (
      <section class='full-width Template-brand-featured qa-quicklinks-container quicklinks-wrapper homepage-widget-wrapper custom-quicklink'>
        <div class='sitewidth'>
          <div class='col'>
            {
              title ? <h3 className='widget__heading'>{title}</h3> : null
            }
            <QuickLinksList>
              {data.map((item, idx: number) =>
                <QuickLink
                  key={idx}
                  item={item}
                  idx={idx}
                  enableBorder={settings.enableBorder}
                  borderRadius={settings.borderRadius}
                  isVisibleDesktop={showAll || idx < itemsPerContainer}
                />)}
            </QuickLinksList>
          </div>
        </div>
        {(data.length > itemsPerContainer) &&
          <ShowMoreButton
            quickLinksLength={data.length}
            itemsPerContainer={itemsPerContainer}
            showMore={this.showMoreHandler}
            showAll={showAll}
          />}
      </section>
    )
  }
}
